import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import TournamentAwardsListPresentation from '../../../tournamentAwards/List/TournamentAwardsListPresentation';

/**
 * Maps props to state for TeamAwardsList
 */
const mapStateToProps = (state, ownProps) => ({
  awards: ownProps.awards || [],
  loading: ownProps.loading || false,
  query: ownProps.query || { sort: { field: 'tournamentStartDate', order: 'desc' } },
  pagination: ownProps.pagination || { page: 1, itemsPerPage: 10 },
  total: ownProps.total || 0
});

/**
 * Component to display tournament awards for a team with pagination
 */
const TeamAwardsList = (props) => {
  const {
    awards,
    loading,
    type,
    query,
    pagination,
    total,
    onPaginate,
    onSort,
    onRowClick
  } = props;
  
  // Different headers based on whether we're showing winner or runner-up awards
  const headers = type === 'winner' 
    ? [
        { id: 'competition.name', labelKey: 'field_competition' },
        { id: 'tournamentName', labelKey: 'field_tournament' },
        { id: 'runnerUpTeam.name', labelKey: 'field_runnerUp' }
      ]
    : [
        { id: 'competition.name', labelKey: 'field_competition' },
        { id: 'tournamentName', labelKey: 'field_tournament' },
        { id: 'winnerTeam.name', labelKey: 'field_winner' }
      ];

  return (
    <TournamentAwardsListPresentation
      awards={awards}
      loading={loading}
      headers={headers}
      query={query}
      pagination={pagination}
      total={total}
      onPaginate={onPaginate}
      onSort={onSort}
      onRowClick={onRowClick}
    />
  );
};

export default connect(mapStateToProps)(injectIntl(TeamAwardsList));
